/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { httpClient } from "../../orval/http-client";
import type { ErrorType, BodyType } from "../../orval/http-client";
import { domainQueryKey } from "../../orval/query-key";
import type {
  CallMeRequest,
  ConfirmPaymentMethodRequest,
  ContactMeRequest,
  CreateCustomerSessionRequest,
  CreateCustomerSessionResponse,
  ErrorResponse,
  GetProductPriceParams,
  GetUpgradePreviewParams,
  Invoice,
  PaymentMethod,
  ProductPrice,
  RegisterInvoiceRequest,
  SubscriptionItem,
  SubscriptionSessionRequest,
  SubscriptionSessionResponse,
  SubscriptionSessionStatusResponse,
  UpgradePreviewResponse,
  UpgradeSubscriptionRequest,
} from "../model";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K,
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const createCustomerSession = (
  createCustomerSessionRequest: BodyType<CreateCustomerSessionRequest>,
  options?: SecondParameter<typeof httpClient>,
  signal?: AbortSignal,
) => {
  return httpClient<CreateCustomerSessionResponse>(
    {
      url: `/customer`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createCustomerSessionRequest,
      signal,
    },
    options,
  );
};

export const getCreateCustomerSessionMutationKey = () =>
  ["createCustomerSession"] as const;

export const getCreateCustomerSessionMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCustomerSession>>,
    TError,
    CreateCustomerSessionMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createCustomerSession>>,
  TError,
  CreateCustomerSessionMutationVariables,
  TContext
> => {
  const mutationKey = getCreateCustomerSessionMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createCustomerSession>>,
    CreateCustomerSessionMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return createCustomerSession(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateCustomerSessionMutationResult = NonNullable<
  Awaited<ReturnType<typeof createCustomerSession>>
>;
export type CreateCustomerSessionMutationBody =
  BodyType<CreateCustomerSessionRequest>;
export type CreateCustomerSessionMutationError = ErrorType<ErrorResponse>;
export type CreateCustomerSessionMutationVariables = {
  data: BodyType<CreateCustomerSessionRequest>;
};

export const useCreateCustomerSession = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createCustomerSession>>,
      TError,
      CreateCustomerSessionMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpClient>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createCustomerSession>>,
  TError,
  CreateCustomerSessionMutationVariables,
  TContext
> => {
  return useMutation(
    getCreateCustomerSessionMutationOptions(options),
    queryClient,
  );
};
export const reactivateSubscription = (
  subscriptionId: string,
  options?: SecondParameter<typeof httpClient>,
  signal?: AbortSignal,
) => {
  return httpClient<void>(
    {
      url: `/customer/subscription/${subscriptionId}/reactivate`,
      method: "POST",
      signal,
    },
    options,
  );
};

export const getReactivateSubscriptionMutationKey = () =>
  ["reactivateSubscription"] as const;

export const getReactivateSubscriptionMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reactivateSubscription>>,
    TError,
    ReactivateSubscriptionMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof reactivateSubscription>>,
  TError,
  ReactivateSubscriptionMutationVariables,
  TContext
> => {
  const mutationKey = getReactivateSubscriptionMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reactivateSubscription>>,
    ReactivateSubscriptionMutationVariables
  > = (props) => {
    const { subscriptionId } = props ?? {};

    return reactivateSubscription(subscriptionId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReactivateSubscriptionMutationResult = NonNullable<
  Awaited<ReturnType<typeof reactivateSubscription>>
>;

export type ReactivateSubscriptionMutationError = ErrorType<ErrorResponse>;
export type ReactivateSubscriptionMutationVariables = {
  subscriptionId: string;
};

export const useReactivateSubscription = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof reactivateSubscription>>,
      TError,
      ReactivateSubscriptionMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpClient>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof reactivateSubscription>>,
  TError,
  ReactivateSubscriptionMutationVariables,
  TContext
> => {
  return useMutation(
    getReactivateSubscriptionMutationOptions(options),
    queryClient,
  );
};
export const upgradeSubscription = (
  upgradeSubscriptionRequest: BodyType<UpgradeSubscriptionRequest>,
  options?: SecondParameter<typeof httpClient>,
  signal?: AbortSignal,
) => {
  return httpClient<void>(
    {
      url: `/customer/subscription/upgrade`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: upgradeSubscriptionRequest,
      signal,
    },
    options,
  );
};

export const getUpgradeSubscriptionMutationKey = () =>
  ["upgradeSubscription"] as const;

export const getUpgradeSubscriptionMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof upgradeSubscription>>,
    TError,
    UpgradeSubscriptionMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof upgradeSubscription>>,
  TError,
  UpgradeSubscriptionMutationVariables,
  TContext
> => {
  const mutationKey = getUpgradeSubscriptionMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof upgradeSubscription>>,
    UpgradeSubscriptionMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return upgradeSubscription(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpgradeSubscriptionMutationResult = NonNullable<
  Awaited<ReturnType<typeof upgradeSubscription>>
>;
export type UpgradeSubscriptionMutationBody =
  BodyType<UpgradeSubscriptionRequest>;
export type UpgradeSubscriptionMutationError = ErrorType<ErrorResponse>;
export type UpgradeSubscriptionMutationVariables = {
  data: BodyType<UpgradeSubscriptionRequest>;
};

export const useUpgradeSubscription = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof upgradeSubscription>>,
      TError,
      UpgradeSubscriptionMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpClient>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof upgradeSubscription>>,
  TError,
  UpgradeSubscriptionMutationVariables,
  TContext
> => {
  return useMutation(
    getUpgradeSubscriptionMutationOptions(options),
    queryClient,
  );
};
export const createSubscriptionSession = (
  subscriptionSessionRequest: BodyType<SubscriptionSessionRequest>,
  options?: SecondParameter<typeof httpClient>,
  signal?: AbortSignal,
) => {
  return httpClient<SubscriptionSessionResponse>(
    {
      url: `/customer/subscription/session`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: subscriptionSessionRequest,
      signal,
    },
    options,
  );
};

export const getCreateSubscriptionSessionMutationKey = () =>
  ["createSubscriptionSession"] as const;

export const getCreateSubscriptionSessionMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSubscriptionSession>>,
    TError,
    CreateSubscriptionSessionMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSubscriptionSession>>,
  TError,
  CreateSubscriptionSessionMutationVariables,
  TContext
> => {
  const mutationKey = getCreateSubscriptionSessionMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSubscriptionSession>>,
    CreateSubscriptionSessionMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return createSubscriptionSession(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateSubscriptionSessionMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSubscriptionSession>>
>;
export type CreateSubscriptionSessionMutationBody =
  BodyType<SubscriptionSessionRequest>;
export type CreateSubscriptionSessionMutationError = ErrorType<ErrorResponse>;
export type CreateSubscriptionSessionMutationVariables = {
  data: BodyType<SubscriptionSessionRequest>;
};

export const useCreateSubscriptionSession = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createSubscriptionSession>>,
      TError,
      CreateSubscriptionSessionMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpClient>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createSubscriptionSession>>,
  TError,
  CreateSubscriptionSessionMutationVariables,
  TContext
> => {
  return useMutation(
    getCreateSubscriptionSessionMutationOptions(options),
    queryClient,
  );
};
export const createPaymentMethodSession = (
  options?: SecondParameter<typeof httpClient>,
  signal?: AbortSignal,
) => {
  return httpClient<SubscriptionSessionResponse>(
    { url: `/customer/payment-method/session`, method: "POST", signal },
    options,
  );
};

export const getCreatePaymentMethodSessionMutationKey = () =>
  ["createPaymentMethodSession"] as const;

export const getCreatePaymentMethodSessionMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPaymentMethodSession>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof httpClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createPaymentMethodSession>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = getCreatePaymentMethodSessionMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createPaymentMethodSession>>,
    void
  > = () => {
    return createPaymentMethodSession(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreatePaymentMethodSessionMutationResult = NonNullable<
  Awaited<ReturnType<typeof createPaymentMethodSession>>
>;

export type CreatePaymentMethodSessionMutationError = ErrorType<ErrorResponse>;

export const useCreatePaymentMethodSession = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createPaymentMethodSession>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof httpClient>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createPaymentMethodSession>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getCreatePaymentMethodSessionMutationOptions(options),
    queryClient,
  );
};
export const confirmPaymentMethod = (
  confirmPaymentMethodRequest: BodyType<ConfirmPaymentMethodRequest>,
  options?: SecondParameter<typeof httpClient>,
  signal?: AbortSignal,
) => {
  return httpClient<void>(
    {
      url: `/customer/payment-method/confirm`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: confirmPaymentMethodRequest,
      signal,
    },
    options,
  );
};

export const getConfirmPaymentMethodMutationKey = () =>
  ["confirmPaymentMethod"] as const;

export const getConfirmPaymentMethodMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof confirmPaymentMethod>>,
    TError,
    ConfirmPaymentMethodMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof confirmPaymentMethod>>,
  TError,
  ConfirmPaymentMethodMutationVariables,
  TContext
> => {
  const mutationKey = getConfirmPaymentMethodMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof confirmPaymentMethod>>,
    ConfirmPaymentMethodMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return confirmPaymentMethod(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ConfirmPaymentMethodMutationResult = NonNullable<
  Awaited<ReturnType<typeof confirmPaymentMethod>>
>;
export type ConfirmPaymentMethodMutationBody =
  BodyType<ConfirmPaymentMethodRequest>;
export type ConfirmPaymentMethodMutationError = ErrorType<ErrorResponse>;
export type ConfirmPaymentMethodMutationVariables = {
  data: BodyType<ConfirmPaymentMethodRequest>;
};

export const useConfirmPaymentMethod = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof confirmPaymentMethod>>,
      TError,
      ConfirmPaymentMethodMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpClient>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof confirmPaymentMethod>>,
  TError,
  ConfirmPaymentMethodMutationVariables,
  TContext
> => {
  return useMutation(
    getConfirmPaymentMethodMutationOptions(options),
    queryClient,
  );
};
export const sendRegisterInvoiceRequest = (
  registerInvoiceRequest: BodyType<RegisterInvoiceRequest>,
  options?: SecondParameter<typeof httpClient>,
  signal?: AbortSignal,
) => {
  return httpClient<void>(
    {
      url: `/customer/invoice`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: registerInvoiceRequest,
      signal,
    },
    options,
  );
};

export const getSendRegisterInvoiceRequestMutationKey = () =>
  ["sendRegisterInvoiceRequest"] as const;

export const getSendRegisterInvoiceRequestMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendRegisterInvoiceRequest>>,
    TError,
    SendRegisterInvoiceRequestMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendRegisterInvoiceRequest>>,
  TError,
  SendRegisterInvoiceRequestMutationVariables,
  TContext
> => {
  const mutationKey = getSendRegisterInvoiceRequestMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendRegisterInvoiceRequest>>,
    SendRegisterInvoiceRequestMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return sendRegisterInvoiceRequest(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendRegisterInvoiceRequestMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendRegisterInvoiceRequest>>
>;
export type SendRegisterInvoiceRequestMutationBody =
  BodyType<RegisterInvoiceRequest>;
export type SendRegisterInvoiceRequestMutationError = ErrorType<ErrorResponse>;
export type SendRegisterInvoiceRequestMutationVariables = {
  data: BodyType<RegisterInvoiceRequest>;
};

export const useSendRegisterInvoiceRequest = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof sendRegisterInvoiceRequest>>,
      TError,
      SendRegisterInvoiceRequestMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpClient>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof sendRegisterInvoiceRequest>>,
  TError,
  SendRegisterInvoiceRequestMutationVariables,
  TContext
> => {
  return useMutation(
    getSendRegisterInvoiceRequestMutationOptions(options),
    queryClient,
  );
};
export const sendContactRequest = (
  contactMeRequest: BodyType<ContactMeRequest>,
  options?: SecondParameter<typeof httpClient>,
  signal?: AbortSignal,
) => {
  return httpClient<void>(
    {
      url: `/customer/contact`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: contactMeRequest,
      signal,
    },
    options,
  );
};

export const getSendContactRequestMutationKey = () =>
  ["sendContactRequest"] as const;

export const getSendContactRequestMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendContactRequest>>,
    TError,
    SendContactRequestMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendContactRequest>>,
  TError,
  SendContactRequestMutationVariables,
  TContext
> => {
  const mutationKey = getSendContactRequestMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendContactRequest>>,
    SendContactRequestMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return sendContactRequest(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendContactRequestMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendContactRequest>>
>;
export type SendContactRequestMutationBody = BodyType<ContactMeRequest>;
export type SendContactRequestMutationError = ErrorType<ErrorResponse>;
export type SendContactRequestMutationVariables = {
  data: BodyType<ContactMeRequest>;
};

export const useSendContactRequest = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof sendContactRequest>>,
      TError,
      SendContactRequestMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpClient>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof sendContactRequest>>,
  TError,
  SendContactRequestMutationVariables,
  TContext
> => {
  return useMutation(
    getSendContactRequestMutationOptions(options),
    queryClient,
  );
};
export const createCustomerChange = (
  createCustomerChangeBody: BodyType<string>,
  options?: SecondParameter<typeof httpClient>,
  signal?: AbortSignal,
) => {
  return httpClient<void>(
    {
      url: `/customer/change`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createCustomerChangeBody,
      signal,
    },
    options,
  );
};

export const getCreateCustomerChangeMutationKey = () =>
  ["createCustomerChange"] as const;

export const getCreateCustomerChangeMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCustomerChange>>,
    TError,
    CreateCustomerChangeMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createCustomerChange>>,
  TError,
  CreateCustomerChangeMutationVariables,
  TContext
> => {
  const mutationKey = getCreateCustomerChangeMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createCustomerChange>>,
    CreateCustomerChangeMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return createCustomerChange(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateCustomerChangeMutationResult = NonNullable<
  Awaited<ReturnType<typeof createCustomerChange>>
>;
export type CreateCustomerChangeMutationBody = BodyType<string>;
export type CreateCustomerChangeMutationError = ErrorType<ErrorResponse>;
export type CreateCustomerChangeMutationVariables = { data: BodyType<string> };

export const useCreateCustomerChange = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createCustomerChange>>,
      TError,
      CreateCustomerChangeMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpClient>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createCustomerChange>>,
  TError,
  CreateCustomerChangeMutationVariables,
  TContext
> => {
  return useMutation(
    getCreateCustomerChangeMutationOptions(options),
    queryClient,
  );
};
export const sendCallMeRequest = (
  callMeRequest: BodyType<CallMeRequest>,
  options?: SecondParameter<typeof httpClient>,
  signal?: AbortSignal,
) => {
  return httpClient<void>(
    {
      url: `/customer/call`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: callMeRequest,
      signal,
    },
    options,
  );
};

export const getSendCallMeRequestMutationKey = () =>
  ["sendCallMeRequest"] as const;

export const getSendCallMeRequestMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendCallMeRequest>>,
    TError,
    SendCallMeRequestMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendCallMeRequest>>,
  TError,
  SendCallMeRequestMutationVariables,
  TContext
> => {
  const mutationKey = getSendCallMeRequestMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendCallMeRequest>>,
    SendCallMeRequestMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return sendCallMeRequest(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendCallMeRequestMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendCallMeRequest>>
>;
export type SendCallMeRequestMutationBody = BodyType<CallMeRequest>;
export type SendCallMeRequestMutationError = ErrorType<ErrorResponse>;
export type SendCallMeRequestMutationVariables = {
  data: BodyType<CallMeRequest>;
};

export const useSendCallMeRequest = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof sendCallMeRequest>>,
      TError,
      SendCallMeRequestMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpClient>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof sendCallMeRequest>>,
  TError,
  SendCallMeRequestMutationVariables,
  TContext
> => {
  return useMutation(getSendCallMeRequestMutationOptions(options), queryClient);
};
export const getSubscriptions = (
  options?: SecondParameter<typeof httpClient>,
  signal?: AbortSignal,
) => {
  return httpClient<SubscriptionItem[]>(
    { url: `/customer/subscription`, method: "GET", signal },
    options,
  );
};

export const getGetSubscriptionsQueryKey = () =>
  domainQueryKey({}, { url: `/customer/subscription` });

export const useGetSubscriptionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getSubscriptions>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getSubscriptions>>, TError, TData>
  >;
  request?: SecondParameter<typeof httpClient>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = domainQueryKey(
    {},
    { url: `/customer/subscription`, queryOptions },
  );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSubscriptions>>
  > = ({ signal }) => getSubscriptions(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSubscriptions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSubscriptionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSubscriptions>>
>;
export type GetSubscriptionsQueryError = ErrorType<ErrorResponse>;

export function useGetSubscriptions<
  TData = Awaited<ReturnType<typeof getSubscriptions>>,
  TError = ErrorType<ErrorResponse>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSubscriptions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSubscriptions>>,
          TError,
          Awaited<ReturnType<typeof getSubscriptions>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof httpClient>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSubscriptions<
  TData = Awaited<ReturnType<typeof getSubscriptions>>,
  TError = ErrorType<ErrorResponse>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSubscriptions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSubscriptions>>,
          TError,
          Awaited<ReturnType<typeof getSubscriptions>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof httpClient>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSubscriptions<
  TData = Awaited<ReturnType<typeof getSubscriptions>>,
  TError = ErrorType<ErrorResponse>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSubscriptions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpClient>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetSubscriptions<
  TData = Awaited<ReturnType<typeof getSubscriptions>>,
  TError = ErrorType<ErrorResponse>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSubscriptions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpClient>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useGetSubscriptionsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getUpgradePreview = (
  params: GetUpgradePreviewParams,
  options?: SecondParameter<typeof httpClient>,
  signal?: AbortSignal,
) => {
  return httpClient<UpgradePreviewResponse>(
    {
      url: `/customer/subscription/upgrade/preview`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getGetUpgradePreviewQueryKey = (
  params?: GetUpgradePreviewParams,
) =>
  domainQueryKey({ params }, { url: `/customer/subscription/upgrade/preview` });

export const useGetUpgradePreviewQueryOptions = <
  TData = Awaited<ReturnType<typeof getUpgradePreview>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: GetUpgradePreviewParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUpgradePreview>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpClient>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = domainQueryKey(
    { params },
    { url: `/customer/subscription/upgrade/preview`, queryOptions },
  );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUpgradePreview>>
  > = ({ signal }) => getUpgradePreview(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUpgradePreview>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUpgradePreviewQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUpgradePreview>>
>;
export type GetUpgradePreviewQueryError = ErrorType<ErrorResponse>;

export function useGetUpgradePreview<
  TData = Awaited<ReturnType<typeof getUpgradePreview>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: GetUpgradePreviewParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUpgradePreview>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUpgradePreview>>,
          TError,
          Awaited<ReturnType<typeof getUpgradePreview>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof httpClient>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUpgradePreview<
  TData = Awaited<ReturnType<typeof getUpgradePreview>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: GetUpgradePreviewParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUpgradePreview>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUpgradePreview>>,
          TError,
          Awaited<ReturnType<typeof getUpgradePreview>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof httpClient>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUpgradePreview<
  TData = Awaited<ReturnType<typeof getUpgradePreview>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: GetUpgradePreviewParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUpgradePreview>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpClient>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetUpgradePreview<
  TData = Awaited<ReturnType<typeof getUpgradePreview>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: GetUpgradePreviewParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUpgradePreview>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpClient>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useGetUpgradePreviewQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getSubscriptionSession = (
  sessionId: string,
  options?: SecondParameter<typeof httpClient>,
  signal?: AbortSignal,
) => {
  return httpClient<SubscriptionSessionStatusResponse>(
    {
      url: `/customer/subscription/session/${sessionId}`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getGetSubscriptionSessionQueryKey = (sessionId: string) =>
  domainQueryKey(
    { sessionId },
    { url: `/customer/subscription/session/${sessionId}` },
  );

export const useGetSubscriptionSessionQueryOptions = <
  TData = Awaited<ReturnType<typeof getSubscriptionSession>>,
  TError = ErrorType<ErrorResponse>,
>(
  sessionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSubscriptionSession>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpClient>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = domainQueryKey(
    { sessionId },
    { url: `/customer/subscription/session/${sessionId}`, queryOptions },
  );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSubscriptionSession>>
  > = ({ signal }) => getSubscriptionSession(sessionId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: sessionId !== null && sessionId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSubscriptionSession>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSubscriptionSessionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSubscriptionSession>>
>;
export type GetSubscriptionSessionQueryError = ErrorType<ErrorResponse>;

export function useGetSubscriptionSession<
  TData = Awaited<ReturnType<typeof getSubscriptionSession>>,
  TError = ErrorType<ErrorResponse>,
>(
  sessionId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSubscriptionSession>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSubscriptionSession>>,
          TError,
          Awaited<ReturnType<typeof getSubscriptionSession>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof httpClient>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSubscriptionSession<
  TData = Awaited<ReturnType<typeof getSubscriptionSession>>,
  TError = ErrorType<ErrorResponse>,
>(
  sessionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSubscriptionSession>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSubscriptionSession>>,
          TError,
          Awaited<ReturnType<typeof getSubscriptionSession>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof httpClient>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSubscriptionSession<
  TData = Awaited<ReturnType<typeof getSubscriptionSession>>,
  TError = ErrorType<ErrorResponse>,
>(
  sessionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSubscriptionSession>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpClient>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetSubscriptionSession<
  TData = Awaited<ReturnType<typeof getSubscriptionSession>>,
  TError = ErrorType<ErrorResponse>,
>(
  sessionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSubscriptionSession>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpClient>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useGetSubscriptionSessionQueryOptions(
    sessionId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getNextInvoiceAmount = (
  options?: SecondParameter<typeof httpClient>,
  signal?: AbortSignal,
) => {
  return httpClient<number>(
    {
      url: `/customer/subscription/next-invoice-amount`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getGetNextInvoiceAmountQueryKey = () =>
  domainQueryKey({}, { url: `/customer/subscription/next-invoice-amount` });

export const useGetNextInvoiceAmountQueryOptions = <
  TData = Awaited<ReturnType<typeof getNextInvoiceAmount>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getNextInvoiceAmount>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof httpClient>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = domainQueryKey(
    {},
    { url: `/customer/subscription/next-invoice-amount`, queryOptions },
  );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getNextInvoiceAmount>>
  > = ({ signal }) => getNextInvoiceAmount(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getNextInvoiceAmount>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetNextInvoiceAmountQueryResult = NonNullable<
  Awaited<ReturnType<typeof getNextInvoiceAmount>>
>;
export type GetNextInvoiceAmountQueryError = ErrorType<ErrorResponse>;

export function useGetNextInvoiceAmount<
  TData = Awaited<ReturnType<typeof getNextInvoiceAmount>>,
  TError = ErrorType<ErrorResponse>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getNextInvoiceAmount>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNextInvoiceAmount>>,
          TError,
          Awaited<ReturnType<typeof getNextInvoiceAmount>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof httpClient>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetNextInvoiceAmount<
  TData = Awaited<ReturnType<typeof getNextInvoiceAmount>>,
  TError = ErrorType<ErrorResponse>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getNextInvoiceAmount>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNextInvoiceAmount>>,
          TError,
          Awaited<ReturnType<typeof getNextInvoiceAmount>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof httpClient>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetNextInvoiceAmount<
  TData = Awaited<ReturnType<typeof getNextInvoiceAmount>>,
  TError = ErrorType<ErrorResponse>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getNextInvoiceAmount>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpClient>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetNextInvoiceAmount<
  TData = Awaited<ReturnType<typeof getNextInvoiceAmount>>,
  TError = ErrorType<ErrorResponse>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getNextInvoiceAmount>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpClient>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useGetNextInvoiceAmountQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getProductPrice = (
  params: GetProductPriceParams,
  options?: SecondParameter<typeof httpClient>,
  signal?: AbortSignal,
) => {
  return httpClient<ProductPrice>(
    { url: `/customer/product-price`, method: "GET", params, signal },
    options,
  );
};

export const getGetProductPriceQueryKey = (params?: GetProductPriceParams) =>
  domainQueryKey({ params }, { url: `/customer/product-price` });

export const useGetProductPriceQueryOptions = <
  TData = Awaited<ReturnType<typeof getProductPrice>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: GetProductPriceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProductPrice>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpClient>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = domainQueryKey(
    { params },
    { url: `/customer/product-price`, queryOptions },
  );

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductPrice>>> = ({
    signal,
  }) => getProductPrice(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProductPrice>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProductPriceQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProductPrice>>
>;
export type GetProductPriceQueryError = ErrorType<ErrorResponse>;

export function useGetProductPrice<
  TData = Awaited<ReturnType<typeof getProductPrice>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: GetProductPriceParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProductPrice>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductPrice>>,
          TError,
          Awaited<ReturnType<typeof getProductPrice>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof httpClient>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetProductPrice<
  TData = Awaited<ReturnType<typeof getProductPrice>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: GetProductPriceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProductPrice>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductPrice>>,
          TError,
          Awaited<ReturnType<typeof getProductPrice>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof httpClient>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetProductPrice<
  TData = Awaited<ReturnType<typeof getProductPrice>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: GetProductPriceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProductPrice>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpClient>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetProductPrice<
  TData = Awaited<ReturnType<typeof getProductPrice>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: GetProductPriceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProductPrice>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpClient>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useGetProductPriceQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getPaymentMethod = (
  options?: SecondParameter<typeof httpClient>,
  signal?: AbortSignal,
) => {
  return httpClient<PaymentMethod>(
    { url: `/customer/payment-method`, method: "GET", signal },
    options,
  );
};

export const getGetPaymentMethodQueryKey = () =>
  domainQueryKey({}, { url: `/customer/payment-method` });

export const useGetPaymentMethodQueryOptions = <
  TData = Awaited<ReturnType<typeof getPaymentMethod>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getPaymentMethod>>, TError, TData>
  >;
  request?: SecondParameter<typeof httpClient>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = domainQueryKey(
    {},
    { url: `/customer/payment-method`, queryOptions },
  );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPaymentMethod>>
  > = ({ signal }) => getPaymentMethod(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPaymentMethod>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPaymentMethodQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPaymentMethod>>
>;
export type GetPaymentMethodQueryError = ErrorType<ErrorResponse>;

export function useGetPaymentMethod<
  TData = Awaited<ReturnType<typeof getPaymentMethod>>,
  TError = ErrorType<ErrorResponse>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPaymentMethod>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentMethod>>,
          TError,
          Awaited<ReturnType<typeof getPaymentMethod>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof httpClient>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPaymentMethod<
  TData = Awaited<ReturnType<typeof getPaymentMethod>>,
  TError = ErrorType<ErrorResponse>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPaymentMethod>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentMethod>>,
          TError,
          Awaited<ReturnType<typeof getPaymentMethod>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof httpClient>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPaymentMethod<
  TData = Awaited<ReturnType<typeof getPaymentMethod>>,
  TError = ErrorType<ErrorResponse>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPaymentMethod>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpClient>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetPaymentMethod<
  TData = Awaited<ReturnType<typeof getPaymentMethod>>,
  TError = ErrorType<ErrorResponse>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPaymentMethod>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpClient>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useGetPaymentMethodQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getBilling = (
  options?: SecondParameter<typeof httpClient>,
  signal?: AbortSignal,
) => {
  return httpClient<Invoice[]>(
    { url: `/customer/billing`, method: "GET", signal },
    options,
  );
};

export const getGetBillingQueryKey = () =>
  domainQueryKey({}, { url: `/customer/billing` });

export const useGetBillingQueryOptions = <
  TData = Awaited<ReturnType<typeof getBilling>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getBilling>>, TError, TData>
  >;
  request?: SecondParameter<typeof httpClient>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = domainQueryKey(
    {},
    { url: `/customer/billing`, queryOptions },
  );

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getBilling>>> = ({
    signal,
  }) => getBilling(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getBilling>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetBillingQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBilling>>
>;
export type GetBillingQueryError = ErrorType<ErrorResponse>;

export function useGetBilling<
  TData = Awaited<ReturnType<typeof getBilling>>,
  TError = ErrorType<ErrorResponse>,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBilling>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBilling>>,
          TError,
          Awaited<ReturnType<typeof getBilling>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof httpClient>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetBilling<
  TData = Awaited<ReturnType<typeof getBilling>>,
  TError = ErrorType<ErrorResponse>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBilling>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBilling>>,
          TError,
          Awaited<ReturnType<typeof getBilling>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof httpClient>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetBilling<
  TData = Awaited<ReturnType<typeof getBilling>>,
  TError = ErrorType<ErrorResponse>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBilling>>, TError, TData>
    >;
    request?: SecondParameter<typeof httpClient>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetBilling<
  TData = Awaited<ReturnType<typeof getBilling>>,
  TError = ErrorType<ErrorResponse>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBilling>>, TError, TData>
    >;
    request?: SecondParameter<typeof httpClient>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useGetBillingQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const cancelSubscription = (
  subscriptionId: string,
  options?: SecondParameter<typeof httpClient>,
  signal?: AbortSignal,
) => {
  return httpClient<void>(
    {
      url: `/customer/subscription/${subscriptionId}`,
      method: "DELETE",
      signal,
    },
    options,
  );
};

export const getCancelSubscriptionMutationKey = () =>
  ["cancelSubscription"] as const;

export const getCancelSubscriptionMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelSubscription>>,
    TError,
    CancelSubscriptionMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof cancelSubscription>>,
  TError,
  CancelSubscriptionMutationVariables,
  TContext
> => {
  const mutationKey = getCancelSubscriptionMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cancelSubscription>>,
    CancelSubscriptionMutationVariables
  > = (props) => {
    const { subscriptionId } = props ?? {};

    return cancelSubscription(subscriptionId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CancelSubscriptionMutationResult = NonNullable<
  Awaited<ReturnType<typeof cancelSubscription>>
>;

export type CancelSubscriptionMutationError = ErrorType<ErrorResponse>;
export type CancelSubscriptionMutationVariables = { subscriptionId: string };

export const useCancelSubscription = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof cancelSubscription>>,
      TError,
      CancelSubscriptionMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpClient>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof cancelSubscription>>,
  TError,
  CancelSubscriptionMutationVariables,
  TContext
> => {
  return useMutation(
    getCancelSubscriptionMutationOptions(options),
    queryClient,
  );
};
